// extracted by mini-css-extract-plugin
export default {"root":"recoverPassForm__root__TqQzw","input":"recoverPassForm__input__EmL_r","hint":"recoverPassForm__hint__InMeo","error":"recoverPassForm__error__aeCKu"};